import { Component, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { DataService_Student_Class_Attendance } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-student-class-attendance",
	templateUrl: "./student-class-attendance.component.html",
	styleUrls: ["./student-class-attendance.component.css"],
})
export class StudentClassAttendanceComponent implements OnInit {
	constructor(
		private userService: UserService,
		private personselectorService: PersonSelectorService,
		private classAttendanceService: DataService_Student_Class_Attendance
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//
		//	Init Person Selector
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.SchoolID = this.SelectedPerson.SchoolID;
			this.loadStats();
			// this.onRefresh();
		});
	}

	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////
	user: any;
	LoadingData: any = false;

	StartDate: Date = new Date();
	EndDate: Date = new Date();

	ErrorMessage: any = "";

	private subscriptionPersonSelect: Subscription;
	public SelectedPerson: any;
	SchoolID: any;

	//Stats
	Stats: any;

	PresentCount: any = 0;
	AbsenceCount: any = 0;
	ExcusedAbsenceCount: any = 0;
	TardyCount: any = 0;
	ExcusedTardyCount: any = 0;
	ClassCutCount: any = 0;
	TotalClasses: any = 0;
	PresentPCT: any = 0;
	AbsenceCountPCT: any = 0;
	ExcusedAbsenceCountPCT: any = 0;
	TardyCountPCT: any = 0;
	ExcusedTardyCountPCT: any = 0;
	ClassCutCountPCT: any = 0;

	SelectedEntry: any;

	////////////////////////////////////////
	// Load Data
	////////////////////////////////////////
	loadStats() {
		this.LoadingData = true;

		if (this.SelectedPerson == undefined) {
			this.LoadingData = false;
			return;
		}

		//Format dates
		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.LoadingData = false;
			return;
		}

		this.ResetStats();

		var result = this.classAttendanceService.ClassAttendanceStatsInfoGetList(this.SelectedPerson.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.Stats = response[0];

				this.PresentCount = this.Stats.PresentCount;
				this.PresentPCT = this.Stats.PresentPCT;
				this.AbsenceCount = this.Stats.AbsenceCount;
				this.AbsenceCountPCT = this.Stats.AbsenceCountPCT;
				this.ExcusedAbsenceCount = this.Stats.ExcusedAbsenceCount;
				this.ExcusedAbsenceCountPCT = this.Stats.ExcusedAbsenceCountPCT;
				this.TardyCount = this.Stats.TardyCount;
				this.TardyCountPCT = this.Stats.TardyCountPCT;
				this.ExcusedTardyCount = this.Stats.ExcusedTardyCount;
				this.ExcusedTardyCountPCT = this.Stats.ExcusedTardyCountPCT;
				this.TotalClasses = this.Stats.TotalClasses;
				this.ClassCutCount = this.Stats.ClassCutCount;
				this.ClassCutCountPCT = this.Stats.ClassCutCountPCT;

				this.LoadingData = false;
			},
			(error) => {
				this.LoadingData = false;
			}
		);
	}

	ResetStats() {
		this.PresentCount = 0;
		this.AbsenceCount = 0;
		this.ExcusedAbsenceCount = 0;
		this.TardyCount = 0;
		this.ExcusedTardyCount = 0;
		this.ClassCutCount = 0;
		this.TotalClasses = 0;
		this.PresentPCT = 0;
		this.AbsenceCountPCT = 0;
		this.ExcusedAbsenceCountPCT = 0;
		this.TardyCountPCT = 0;
		this.ExcusedTardyCountPCT = 0;
		this.ClassCutCountPCT = 0;
	}
	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////

	////////////////////////////////////////

	////////////////////////////////////////
	// Events
	////////////////////////////////////////
	onStartDateChange(val) {
		this.StartDate = val;

		//Load data
		this.loadStats();
	}
	onEndDateChange(val) {
		this.EndDate = val;

		//Load data
		this.loadStats();
	}
	onEntrySelected(val) {
		this.SelectedEntry = val;
	}
	onRefreshStats() {
		var temp = this.SelectedEntry;
		this.SelectedEntry = null;
		this.SelectedEntry = temp;

		this.loadStats();
	}
	////////////////////////////////////////
}
